const initialState = {
  priceChanges: [],
  page: 1,
  filtersFormState: {
    data: {
      // sort: 'remainingValue',
    }
  },
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_PRICE_CHANGES': {
      const { priceChanges, page } = payload;
      return {
        ...state,
        priceChanges,
        page,
      };
    }
    case 'PRICE_CHANGES_FILTERS_CHANGE': {
      const { filtersFormState } = payload;
      return {
        ...state,
        filtersFormState,
        page: 1,
      };
    }
    case 'PRICE_CHANGES_NEXT_PAGE': {
      const page = Number(state.page);
      return {
        ...state,
        page: page + 1,
      };
    }
    case 'PRICE_CHANGES_PREVIOUS_PAGE': {
      const page = Number(state.page);
      return {
        ...state,
        page: page > 1 ? page - 1 : 1,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/PriceChanges/PriceChanges.reducer.js